import { render, staticRenderFns } from "./ProductTwelve.vue?vue&type=template&id=5bf2760a&"
import script from "./ProductTwelve.vue?vue&type=script&lang=js&"
export * from "./ProductTwelve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bf2760a')) {
      api.createRecord('5bf2760a', component.options)
    } else {
      api.reload('5bf2760a', component.options)
    }
    module.hot.accept("./ProductTwelve.vue?vue&type=template&id=5bf2760a&", function () {
      api.rerender('5bf2760a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductTwelve.vue"
export default component.exports